import React, { useState, useEffect } from 'react';
import { Input, Row, Form, Col, notification, Button } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { PlusOutlined } from '@ant-design/icons';
import RequestHandler from '../../util/RequestHandler';

const layout = { labelCol: { span: 10 }, wrapperCol: { span: 11 } };
const tailLayout = { wrapperCol: { offset: 8, span: 16 } };

const MonthlyPlanTypeUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ Name: props.Name || '' });
  }, [props.Name, form]);

  const onFinishUpdate = (values) => {
    setLoading(true);
    RequestHandler.put(
      `/MonthlyPlanType`,
      {
        id: props.MonthlyPlanTypeId,
        name: values.Name,
      },
      false,
      { rawResponse: true }
    )
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: 'BAŞARILI',
            description: 'Güncelleme işlemi başarı ile gerçekleşti.',
            duration: 2,
          });
          props.sendDataForUpdate('success');
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Form
        {...layout}
        name="monthly-plan-type-update"
        form={form}
        onFinish={onFinishUpdate}
        onFinishFailed={() => setLoading(false)}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={24}>
                <Form.Item
                  name="Name"
                  style={{ marginTop: '4%' }}
                  label="Tip Adı"
                  rules={[{ required: true, message: 'Lütfen Tip adı alanını boş bırakmayın.' }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={18} />
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
            </>
          )}
          
          {isTabletOrMobile && (
            <>
              <Col span={24}>
                <Form.Item
                  name="Name"
                  style={{ marginTop: '4%' }}
                  label="Tip Adı"
                  rules={[{ required: true, message: 'Lütfen Tip adı alanını boş bırakmayın.' }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={10} />
              <Col span={8}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6} />
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default MonthlyPlanTypeUpdate;
